<template>
  <div>
    <v-dialog
    @keydown.esc="isOpen=false"
    style="z-index: 9999"
    v-model="isOpen"
    persistent
    max-width="550px">
      <v-card>
        <v-card-title>
          <span>Factura <span class="primary--text">{{ invoice.uuid }}</span></span>
        </v-card-title>
        <v-divider />
        <br>
        <v-card-text class="text-justify">
          <div>
            <span class="subtitle-1">La información mostrada es verificada por mediante del Servicio de Administración Tributaria (SAT).</span>
          </div>
          <br>
          <div>
            <span class="subtitle-1"><span class="font-weight-bold">Estatus:</span> {{ data.status }}</span>
          </div>
          <div>
            <span class="subtitle-1"><span class="font-weight-bold">Es cancelable:</span> {{ data.isCanceled }}</span>
          </div>
          <div>
            <span class="subtitle-1" v-if="data.status === 'Cancelado'"><span class="font-weight-bold">Estatus de cancelación:</span> {{ data.statusCanceled }}</span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>

export default {
  data () {
    return {
      overlay: false,
      isOpen: false,
      invoice: {},
      data: {}
    }
  },
  methods: {
    open (invoice, data) {
      this.isOpen = true
      this.invoice = invoice
      this.data = data
    },
    resetData () {
      this.invoice = {}
      this.data = {}
    },
    closeDialog: function () {
      this.resetData()
      this.isOpen = false
    }
  }
}
</script>
